import {usePageTitle, useScrollToTop} from "../hooks";
import {ComiteSection} from "../components/sections";

const Comites = () => {
    usePageTitle('Comités');
    useScrollToTop();
    return (
        <div>
            <ComiteSection />
        </div>
    );
}

export default Comites;